/* eslint-disable arrow-body-style */
import { Injectable } from "@angular/core";
import { authSelectors } from "@content-platform/web-angular-shared-util-auth";
import { UserPermissionListGuard } from "@content-platform/web-angular-shared-data-access-application-api";
import { Store } from "@ngrx/store";
import { filter, switchMap } from 'rxjs';
import * as i0 from "@angular/core";
import * as i1 from "@content-platform/web-angular-shared-data-access-application-api";
import * as i2 from "@ngrx/store";
export class PermissionsOktaWrapGuard {
    constructor(permissionGuard, store) {
        this.permissionGuard = permissionGuard;
        this.store = store;
        this.user$ = this.store.select(authSelectors.getADUser);
    }
    canActivateChild() {
        return this.checkIfCanActivate();
    }
    canActivate() {
        return this.checkIfCanActivate();
    }
    checkIfCanActivate() {
        return this.user$.pipe(filter((user) => !!user), switchMap(() => {
            return this.permissionGuard.canActivate();
        }));
    }
    static { this.ɵfac = function PermissionsOktaWrapGuard_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || PermissionsOktaWrapGuard)(i0.ɵɵinject(i1.UserPermissionListGuard), i0.ɵɵinject(i2.Store)); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: PermissionsOktaWrapGuard, factory: PermissionsOktaWrapGuard.ɵfac }); }
}
//# sourceMappingURL=permissions-okta-wrap.guard.js.map